import React from 'react';
import { motion } from 'framer-motion';

interface MenuItem {
  name: string;
  description: string;
  price: string;
  emoji: string;
  color: string;
}

const menuItems: MenuItem[] = [
  {
    name: 'Lemonade',
    description: 'Classic, tangy, and made fresh with real lemons. Our lemonade is a fan favorite and super refreshing!',
    price: '$3.00',
    emoji: '🍋',
    color: 'bg-yellow-100'
  },
  {
    name: 'Pink Lemonade',
    description: 'This pink cutie is sweet, a little tart, and super photogenic. It\'s made with love and secret ingredients!',
    price: '$3.00',
    emoji: '🍑',
    color: 'bg-pink-100'
  },
  {
    name: 'Cupcakes',
    description: 'Soft, fluffy cupcakes baked by our very own team of besties. They come in chocolate and vanilla!',
    price: '$3.00',
    emoji: '🧁',
    color: 'bg-purple-100'
  },
  {
    name: 'Gluten Free Cookies',
    description: 'Crispy on the edges, chewy in the center—our gluten-free cookies are made with premium ingredients for a treat that everyone can enjoy.',
    price: '$3.00',
    emoji: '🍪',
    color: 'bg-amber-100'
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const item = {
  hidden: { opacity: 0, y: 50 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const MenuPage: React.FC = () => {
  return (
    <div className="pt-2">
      <motion.h1 
        className="text-3xl md:text-4xl font-baloo text-yellow-500 mb-6 md:mb-8 text-center md:text-left"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        Our Menu
      </motion.h1>
      
      <motion.div 
        className="grid grid-cols-1 md:grid-cols-2 gap-6"
        variants={container}
        initial="hidden"
        animate="show"
      >
        {menuItems.map((menuItem, index) => (
          <motion.div 
            key={index}
            className={`card ${menuItem.color} hover:shadow-xl transition-shadow border-2 border-white`}
            variants={item}
            whileHover={{ 
              scale: 1.03, 
              transition: { duration: 0.2 } 
            }}
          >
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-baloo font-bold">{menuItem.name}</h2>
              <span className="text-3xl">{menuItem.emoji}</span>
            </div>
            
            <p className="font-comic mb-4">{menuItem.description}</p>
            
            <div className="text-right">
              <span className="text-2xl font-baloo font-bold text-pink-500">{menuItem.price}</span>
            </div>
          </motion.div>
        ))}
      </motion.div>
      
      <motion.div 
        className="mt-8 p-4 bg-yellow-50 rounded-xl border-2 border-yellow-100"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
      >
        <p className="font-comic text-center text-lg">
          <span className="font-bold">Note:</span> All of our treats are made fresh daily with love!
        </p>
      </motion.div>
    </div>
  );
};

export default MenuPage; 